export const MAX_PHOTO_BYTES = 128 * 1024;
export const PHOTO_SIZE = 320;
export interface OperatorPhoto { photoUrl: string | null }

export function operatorPhotoPath(id: string): string {
  return `/api/public/operator-photos/${id}`;
}
